import apiClient from "../lib/apiClients";

export type DashboardStageKey =
  | "received"
  | "investigation"
  | "council"
  | "appeal"
  | "closed"
  | "other";

export interface DashboardCount {
  label: string;
  count: number;
}

export interface DashboardCase {
  id: string;
  application_number: string | null;
  accused_prosecutor_name: string | null;
  status: string | null;
  created_at: string;
}

export interface DashboardHearing {
  complaint_id: string;
  application_number: string | null;
  accused_prosecutor_name: string | null;
  hearing_date: string;
  status: string | null;
}

export interface ProsecutorDisciplineDashboard {
  scope: { type: "assigned" | "admin_unit" | "all"; admin_unit_id: string | null };
  range: { from: string | null; to: string | null };
  totals: Record<DashboardStageKey, number> & {
    total: number;
    previous_total: number | null;
  };
  by_status: { status: string | null; count: number }[];
  appeals: {
    appeal_requests: number;
    accused_appeals: number;
    court_appeals: number;
    summons: number;
  };
  trend: { month: string; received: number; closed: number }[];
  offence_types: DashboardCount[];
  decision_types: DashboardCount[];
  recent_cases: DashboardCase[];
  upcoming_hearings: DashboardHearing[];
}

// The backend scopes the result by the caller's token (role and
// administration unit); only the date range is chosen here.
export const fetchProsecutorDisciplineDashboard = async (range: {
  from?: string;
  to?: string;
}) => {
  const params = new URLSearchParams();
  if (range.from) params.set("from", range.from);
  if (range.to) params.set("to", range.to);
  const query = params.toString();
  const { data } = await apiClient.get<ProsecutorDisciplineDashboard>(
    `/prosecutor-decipiline/dashboard/${query ? `?${query}` : ""}`,
  );
  return data;
};

// The unit name comes through the discipline backend, which asks HRMS; the
// browser cannot call HRMS directly. Empty when the name is not available.
export const fetchAdminUnitName = async (adminUnit: string) => {
  const { data } = await apiClient.get<{ admin_unit?: { unit_name?: string } | null }>(
    `/prosecutor-decipiline/complaints/user-org-details/?admin_unit_uuid=${encodeURIComponent(adminUnit)}`,
  );
  return data?.admin_unit?.unit_name || "";
};
